skrilla.service('csvService', function(envService, queryService, $window) {

    const openInV2CSVExporter = (path, query) =>{
        let request = {
            token: $window.localStorage.token.replace("Bearer ", ""),
            redirect: `csvExporter${encodeURIComponent(queryService.getQueryString({...query, path}))}`
        }
        let url = `${envService.read("v2Url")}/injest${queryService.getQueryString(request)}`
        window.open(url, "_blank");
    }

    return {
        openInV2CSVExporter: openInV2CSVExporter
    };
});
